import { motion } from "framer-motion";
import { ArrBtn } from "components/elements";
import { twMerge } from "tailwind-merge";

export default function FeatureItem({ data }) {
  return (
    <div className="item-ls">
      {data.map((feature, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, x: -100 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.3 + index * 0.1 }}
          className="item"
        >
          <span className="tit-red">
            <ArrBtn />
            {feature.title}
            {feature.titleMedium && <span className={twMerge("font-medium ml-[-5px]")}>{feature.titleMedium}</span>}
          </span>
          <ul className="ls">
            {feature.items.map((item, index) => (
              <li key={index}>
                <span className="dot"></span>
                <span dangerouslySetInnerHTML={{ __html: item }} />
              </li>
            ))}
          </ul>
        </motion.div>
      ))}
    </div>
  );
}
